module.exports = __webpack_public_path__ + "static/media/ppt.b3e2bbb9.svg";